import React from 'react';
import PropTypes from 'prop-types';

import {
  Container,
  Content,
  Image,
  Head,
  Mouth,
  RightShoulder,
  LeftShoulder,
  Abdomen,
  LeftPulse,
  RightPulse,
  LeftGroin,
  RightGroin,
  LeftThigh,
  RightThigh,
  LeftKnee,
  RightKnee,
} from './styles';

import front from '~/assets/front-person-hdpi.png';

function BloodFront({ region, decrease }) {
  return (
    <Container>
      <Content decrease={decrease}>
        <Image src={front} alt="Região frontal" />

        {/* Cabeça */}
        <Head decrease={decrease} active={region === `cabeça`} />

        {/* Boca */}
        <Mouth decrease={decrease} active={region === `boca`} />

        {/* Ombro esquerdo */}
        <LeftShoulder
          decrease={decrease}
          active={region === `ombro esquerdo`}
        />

        {/* Ombro direito */}
        <RightShoulder
          decrease={decrease}
          active={region === `ombro direito`}
        />

        {/* Abdômen */}
        <Abdomen decrease={decrease} active={region === `abdômen`} />

        {/* Pulso esquerdo */}
        <LeftPulse decrease={decrease} active={region === `pulso esquerdo`} />

        {/* Pulso direito */}
        <RightPulse decrease={decrease} active={region === `pulso direito`} />

        {/* Virilha esquerda */}
        <LeftGroin decrease={decrease} active={region === `virilha esquerda`} />

        {/* Virilha direita */}
        <RightGroin decrease={decrease} active={region === `virilha direita`} />

        {/* Coxa esquerda */}
        <LeftThigh decrease={decrease} active={region === `coxa esquerda`} />

        {/* Coxa direita */}
        <RightThigh decrease={decrease} active={region === `coxa direita`} />

        {/* Joelho esquerdo */}
        <LeftKnee decrease={decrease} active={region === `joelho esquerdo`} />

        {/* Joelho direito */}
        <RightKnee decrease={decrease} active={region === `joelho direito`} />
      </Content>
    </Container>
  );
}

BloodFront.propTypes = {
  region: PropTypes.string,
  decrease: PropTypes.bool,
};

BloodFront.defaultProps = {
  region: null,
  decrease: false,
};

export default BloodFront;
